import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertComponent, DisplayInputComponent } from '@components';

import { Status } from '@enums';
import { Profile, User } from '@models';
import { UtilService } from '@services';
import * as UserActions from '@state/user/user.actions';
import { AsylumResult } from 'src/app/models/asylum-result';
import { BiometricResult } from 'src/app/models/biometric-result';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    DisplayInputComponent,
    MatProgressSpinnerModule,
    MatGridListModule,
    AlertComponent
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class UserProfileComponent implements OnChanges {
  @Input() user: User | null = null;
  @Output() createCarTrackProfile: EventEmitter<void> =
    new EventEmitter<void>();

  public profile: Profile | undefined;
  public biometricResult: BiometricResult | undefined;
  public asylumResult: AsylumResult | undefined;

  public loading: boolean = false;
  public error: string | null = null;

  constructor(public utils: UtilService) {}

  async ngOnChanges(): Promise<void> {
    if (this.user && this.user.profile) {
      this.profile = this.user.profile;
      this.biometricResult = this.user.biometricResult;
      this.asylumResult = this.user.asylumResult;
    }
  }

  public get isAsylumValid(): boolean {
    const date = this.asylumResult?.expiryDate.split(' ')[1].split(';')[0];
    const dateStringParts = date?.split('/');
    const newDateString = dateStringParts
      ? dateStringParts[1] + '/' + dateStringParts[0] + '/' + dateStringParts[2]
      : '';
    const expiryDate = newDateString ? new Date(newDateString) : null;
    return (expiryDate && expiryDate > new Date()) || false;
  }

  public async onApproveClicked() {
    this.saveProfileStatus(Status.APPROVED);
  }

  public async onDeclineClicked() {
    this.saveProfileStatus(Status.DECLINED);
  }

  private async saveProfileStatus(status: Status) {
    this.error = '';
    this.loading = true;

    try {
      const profile = this.profile!;
      await this.utils.actionsToPromise(
        UserActions.setUserProfileStatus({ profile, status }),
        UserActions.setUserProfileStatusSuccess,
        UserActions.setUserProfileStatusFailed
      );
    } catch (err: any) {
      this.error = this.utils.getErrorMessage(err);
    }

    this.loading = false;
  }

  public onCreateCarTrackProfile() {
    this.error = '';
    this.loading = true;

    try {
      this.createCarTrackProfile.emit();
    } catch (err: any) {
      this.error = this.utils.getErrorMessage(err);
    }

    this.loading = false;
  }
}
